import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  className = '',
  showIcon = true,
  href = 'https://activatureset.com/cart/52638683463972:1'
}: ButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`group relative inline-flex items-center justify-center gap-3 bg-olive-light text-cream px-8 py-5 rounded-full font-body font-bold text-sm md:text-base tracking-wide uppercase transition-all duration-300 hover:bg-olive-gold hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 no-underline ${className}`} data-id="element-69">
      <span data-id="element-70">{children}</span>
      {showIcon && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-71" />}
    </a>;
}